import React, { memo, useCallback } from "react";
import { useT, withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import { tracker } from "~/common/tracker";
import linkTo from "~/common/utils/linkTo";

import { getTrackerSaReportInfo } from "../../../sensor-config";

import styles from "./index.scss";
interface Props extends WithReduxHocPropsType {
  openAppLink: string;
}

const BulletinBoard = (props: Props): JSX.Element => {
  const t = useT();

  const onClick = useCallback(async (): Promise<void> => {
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickMarketing" }),
    });
    props?.openAppLink && linkTo(props.openAppLink);
  }, [props?.openAppLink]);

  return (
    <div className={styles.wrap} onClick={onClick}>
      <i className={styles.img} />
      <div className={styles.content}>
        <div className={styles.slide}>
          <span className={styles.txt}>{t("新用户在Akulaku APP内购买，再领Rp165000优惠券，下单时使用")}</span>
          <span className={styles.txt}>{t("新用户在Akulaku APP内购买，再领Rp165000优惠券，下单时使用")}</span>
        </div>
      </div>
    </div>
  );
};

export default withRedux((state) => ({
  openAppLink: state.static.openAppLink,
}))(memo(BulletinBoard));
